import { performDraw, addTelemetryMetrics, noop } from '@datadog/browser-core';
const SEGMENT_METRICS_TELEMETRY_NAME = 'Segment network request metrics';
export function startSegmentTelemetry(configuration, telemetry, requestObservable) {
    const segmentTelemetryEnabled = telemetry.enabled && performDraw(configuration.segmentTelemetrySampleRate);
    if (!segmentTelemetryEnabled) {
        return { stop: noop };
    }
    const { unsubscribe } = requestObservable.subscribe((requestEvent) => {
        if (requestEvent.type === 'failure' ||
            requestEvent.type === 'queue-full' ||
            (requestEvent.type === 'success' && requestEvent.payload.isFullSnapshot)) {
            const metrics = createSegmentMetrics(requestEvent.type, requestEvent.bandwidth, requestEvent.payload);
            addTelemetryMetrics(SEGMENT_METRICS_TELEMETRY_NAME, { metrics });
        }
    });
    return {
        stop: unsubscribe,
    };
}
function createSegmentMetrics(result, bandwidthStats, payload) {
    return {
        cssText: {
            count: payload.cssText.count,
            max: payload.cssText.max,
            sum: payload.cssText.sum,
        },
        isFullSnapshot: payload.isFullSnapshot,
        ongoingRequests: {
            count: bandwidthStats.ongoingRequestCount,
            totalSize: bandwidthStats.ongoingByteCount,
        },
        recordCount: payload.recordCount,
        result,
        size: {
            compressed: payload.bytesCount,
            raw: payload.rawSize,
        },
    };
}
//# sourceMappingURL=startSegmentTelemetry.js.map